import styled from '@emotion/styled';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';

export type BtnDirectionsType = 'column' | 'row' | 'row-reverse' | 'column-reverse';

interface ModalActionsBtnsWrapperProps {
  btnDirection: BtnDirectionsType;
}

type ModalContainerProps = React.ComponentProps<typeof Modal> & {
  btnDirection: BtnDirectionsType;
};

const ModalWrapper = styled.div`
  // TODO: Hot fix for broken paddings. For more details https://naspersclassifieds.atlassian.net/browse/DIP-613
  > * {
    box-sizing: border-box;
  }
  z-index: 1040;
  position: fixed;
`;

const ModalContainer = styled(Modal)<ModalContainerProps>`
  max-width: 434px;
  top: 50%;
  left: 50%;

  // TODO: Hot fix for X button alignment. For more details https://naspersclassifieds.atlassian.net/browse/DIP-613
  [aria-label='Close'] {
    align-self: center;
  }
`;

const ModalActionsBtnsWrapper = styled.div<ModalActionsBtnsWrapperProps>`
  display: flex;
  justify-content: center;
  width: ${props => (props.btnDirection.includes('row') ? '80%' : '100%')};
  gap: ${props => props.btnDirection.includes('row') && '15px'};
  flex-direction: ${props => props.btnDirection};

  button {
    padding: ${props => props.btnDirection.includes('row') && '5px 25px'};
    margin-bottom: ${props => props.btnDirection.includes('row') && '10px'};
  }
`;

const ModalActions = styled.div`
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
`;

export default {
  ModalContainer,
  ModalWrapper,
  ModalActions,
  ModalActionsBtnsWrapper,
};
